import { useState, useCallback } from 'react';
import { procesoAPI } from '../services/api';

/**
 * Estado y operaciones del módulo Cloud (rediseño 2026-05).
 * - clientes: tabla `clients` (compartida con el módulo TBBC)
 */
export const useProceso = (showNotification) => {
  const [clientes, setClientes] = useState([]);

  const loadClientes = useCallback(async () => {
    try {
      const res = await procesoAPI.getClientes();
      setClientes(res.data.clientes || []);
    } catch (error) {
      showNotification?.('error', 'Error', 'No se pudieron cargar los clientes');
    }
  }, [showNotification]);

  const reorderClientes = useCallback(async (newList) => {
    setClientes(newList);
    try {
      await procesoAPI.reordenarClientes(newList.map((c) => c.id));
    } catch (error) {
      showNotification?.('error', 'Error', 'No se pudo guardar el nuevo orden');
    }
  }, [showNotification]);

  const addCliente = useCallback(async (name) => {
    try {
      await procesoAPI.createCliente(name);
      const res = await procesoAPI.getClientes();
      setClientes(res.data.clientes || []);
      showNotification?.('success', 'Cliente creado', `"${name}" se agregó correctamente`);
      return true;
    } catch (error) {
      showNotification?.('error', 'Error', error.response?.data?.error || 'No se pudo crear el cliente');
      return false;
    }
  }, [showNotification]);

  const removeCliente = useCallback(async (cliente) => {
    try {
      await procesoAPI.deleteCliente(cliente.id);
      setClientes((prev) => prev.filter((c) => c.id !== cliente.id));
      showNotification?.('success', 'Cliente eliminado', `"${cliente.name}" fue eliminado`);
      return true;
    } catch (error) {
      showNotification?.('error', 'Error', 'No se pudo eliminar el cliente');
      return false;
    }
  }, [showNotification]);

  return {
    clientes,
    loadClientes,
    reorderClientes,
    addCliente,
    removeCliente
  };
};
